import React from 'react';
import Box from '@/Atoms/Box';
import CCText from '@/Atoms/CCText';
import Spacer from '@/Atoms/Spacer';
import {FontSizes, vs} from '@/Utils/Dimensions';
import {lbColors} from '@/Screens/Leaderboard/leaderboardTheme';
import LiveBadge from '@/Screens/Leaderboard/components/LiveBadge';

// ── ArenaSectionHeader ───────────────────────────────────────────────────────
// One header treatment shared by every arena tab (Leaderboard / Live games /
// Details) so they open the same way: a bold ink title, an optional LiveBadge
// while the arena is running, an optional trailing node (count/control), and an
// optional muted subtitle underneath. Keeps the wins-leaderboard vocabulary.
const ArenaSectionHeader: React.FC<{
  title: string;
  live?: boolean;
  subtitle?: string;
  trailing?: React.ReactNode;
}> = ({title, live, subtitle, trailing}) => {
  return (
    <>
      <Box
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        style={{marginLeft: 4, marginRight: 4}}>
        <Box flexDirection="row" alignItems="center" gap={9}>
          <CCText
            fontSize={FontSizes[15]}
            fontWeight="bold"
            style={{color: lbColors.ink}}>
            {title}
          </CCText>
          {live && <LiveBadge />}
        </Box>
        {trailing ? <Box>{trailing}</Box> : null}
      </Box>
      {Boolean(subtitle) && (
        <>
          <Spacer spacing={vs(2)} />
          <CCText
            fontSize={FontSizes[11]}
            style={{marginLeft: 4, color: lbColors.muted}}
            data-testid="arena-section-subtitle">
            {subtitle}
          </CCText>
        </>
      )}
    </>
  );
};

export default ArenaSectionHeader;
